<div class="modal-wrapper">
  @if (description) {
    <div class="modal-header">
      <h4 ngbAutoFocus tabindex="0" class="modal-title" id="modal-basic-title">Email {{ description }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
    </div>
  } @else {
    <div class="modal-body">
      <div class="widget-loading text-center">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
    </div>
  }
  @if (description) {
    <div class="modal-body">
      @if (mailGroups.length == 1) {
        <p>
          Click below to launch your email client.
        </p>
      }
      @if (mailGroups.length > 1) {
        <p>
          Multiple emails are often required for large groups of recipients.
          <strong>{{mailGroups.length}} {{ (mailGroups.length > 1 ) ? "emails need" : "email needs"}} to be sent.</strong> Click the buttons below to launch
          your email client with the associated email lists.
        </p>
      }
      @for (mailto of mailGroups; track mailto; let i = $index) {
        <button class="btn btn-primary" (click)="sendEmail(mailto)">Open Email {{ (mailGroups.length > 1 ) ? i + 1 : ""}} to {{ description }}</button>
      }
    </div>
  }
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Cancel</button>
  </div>

</div>
